import React from 'react';
import './Welcome.css';

interface WelcomeProps {
  onGetStarted: () => void;
}

export default function Welcome({ onGetStarted }: WelcomeProps) {
  return (
    <div className="welcome-container">
      <div className="welcome-card">
        <div className="welcome-header">
          <h1>Welcome to OpenBill</h1>
          <div className="welcome-subtitle">Your gateway to transparent government</div>
        </div>
        
        <div className="welcome-content">
          <p className="welcome-message">
            Hi! Welcome to OpenBill. We built this because staying informed shouldn't be overwhelming. If you're like us, you've felt the stress of consuming news through social media - but taking breaks can leave you feeling disconnected from important issues that affect your life. Our app helps you stay informed about legislation and policy changes that matter to you, without the noise and anxiety of traditional news feeds.
          </p>
          
          <div className="welcome-features">
            <div className="feature">
              <span className="feature-icon">📰</span>
              <span className="feature-text">Access to recent House bills with clear summaries</span>
            </div>
            <div className="feature">
              <span className="feature-icon">🗳️</span>
              <span className="feature-text">Vote and comment on bills that matter to you</span>
            </div>
            <div className="feature">
              <span className="feature-icon">🔍</span>
              <span className="feature-text">Search and filter bills by keywords</span>
            </div>
            <div className="feature">
              <span className="feature-icon">📊</span>
              <span className="feature-text">See community sentiment on each bill</span>
            </div>
          </div>
        </div>
        
        <div className="welcome-actions">
          <button onClick={onGetStarted} className="get-started-btn">
            Get Started
          </button>
        </div>
      </div>
    </div>
  );
}
